import { fetchWrapper } from '@/_helpers';

export const analyticsApi = {
    getClientUnitSummaryByTeam: (teamId) => fetchWrapper.get(`analytics/team/${teamId}/clients/unit-summary`),
};
